import PatientAccountItem from './PatientAccountItem';

export default PatientAccountItem;
